var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" Öğrenciler "),_c('v-spacer'),_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Birşeyler ara...","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.Basliklar,"items":_vm.ogrenciler,"search":_vm.search,"sort-by":[
      'isim',
      'soyisim',
      'onumara',
      'vize',
      'final',
      'basari_notu',
      'harf_notu' ],"hide-default-footer":true},scopedSlots:_vm._u([{key:"item.basari_notu",fn:function(ref){
    var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColor(item.basari_notu),"dark":""}},[_vm._v(_vm._s(item.basari_notu))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }